module.exports = __webpack_public_path__ + "static/media/scrum.ba9ee3d8.svg";